import React from 'react';
import { useForm } from 'react-hook-form';

export default function New(props) {
  return (
    <div className="grid lg:grid-cols-5 sm:grid-cols-2 font-[Rubik]">
      <div className="lg:flex hidden flex-col items-center relative lg:col-span-3 sm:col-span-2">
        <img src="/assets/images/bg-authentication.png" alt="bg-authentication" />
        <div className="xl:text-5xl lg:text-4xl sm:text-2xl text-lg text-white font-medium absolute top-[37%] w-2/3">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cursus convallis rhoncus.
        </div>
      </div>
      <div className="lg:col-span-2 sm:col-span-2 lg:mx-[5%] sm:mx-auto my-[5%]">
        <div className="flex justify-between items-center">
          <button className="bg-[#F8F8F8] rounded-[4px] text-[#C5C5C5] lg:text-base text-sm font-medium xl:px-12 lg:px-7 px-6 xl:py-4 lg:py-3 py-2">
            Kembali
          </button>
          <p className="text-[#999999] lg:text-base text-sm">
            {props.question}{' '}
            <a href={props.link} className="text-primary hover:underline">
              {props.auth}
            </a>
          </p>
        </div>
        <div className="mt-[10%]">
          <p className="text-primary lg:text-[30px] text-2xl font-medium">{props.text1}</p>
          <p className="text-[#666666] lg:text-base text-sm">{props.text2}</p>
        </div>
        <form className="grid mt-[8%]" onSubmit={props.onSubmit}>
          <label htmlFor="username" className="text-[#999999] lg:text-base text-sm mt-4">
            Username
          </label>
          <input
            className="bg-[#FAFBFF] border border-[#D1D1D1] rounded text-[#999999] ring-[#666666] lg:text-base text-sm lg:px-5 px-3 lg:py-[13px] py-2"
            type="text"
            value={props.username}
            placeholder="Tulis Nama"
            onChange={props.onInputUsername}
          />

          <label htmlFor="email" className="text-[#999999] lg:text-base text-sm mt-4">
            Email
          </label>
          <input
            className="bg-[#FAFBFF] border border-[#D1D1D1] rounded text-[#999999] ring-[#666666] lg:text-base text-sm lg:px-5 px-3 lg:py-[13px] py-2"
            type="text"
            value={props.email}
            onChange={props.onInputEmail}
            placeholder="Tulis Email"
          />

          <label htmlFor="password" className="text-[#999999] lg:text-base text-sm mt-4">
            Password
          </label>
          <input
            className="bg-[#FAFBFF] border border-[#D1D1D1] rounded text-[#999999] ring-[#666666] lg:text-base text-sm lg:px-5 px-3 lg:py-[13px] py-2"
            type="password"
            value={props.password}
            onChange={props.onInputPassword}
            placeholder="Tulis Password"
          />
          <button
            type="submit"
            className="bg-primary text-white font-medium w-full mt-8 rounded py-4 lg:text-base text-sm">
            {props.text3}
          </button>
        </form>
      </div>
    </div>
  );
}
